import { ajaxURL } from "./localizedData";

/**
 * listen to form submit via ajax
 */
export const newsletterForm = () => {
  const form = document.getElementById(
    "widget-newsletter_form"
  ) as HTMLFormElement;

  if (form) {
    form.onsubmit = (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      fetch(ajaxURL, {
        method: "POST",
        body: formData,
      })
        .then((r) => r.json())
        .catch((e) => console.error(e));
    };
  }
};
